export class Scroller {
  private static getCssProperty(name: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
  }

  public static initialize(): void {
    const scroller = new Scroller();
    scroller.onResize();
    window.addEventListener('scroll', scroller.onScroll.bind(scroller));
    scroller.animateHue();
  }

  // Get the Initial Hue by computing styles once.
  private hueStart = Number(Scroller.getCssProperty('--hue-start'));

  private hueEnd = Number(Scroller.getCssProperty('--hue-end'));

  private scrollPosition = { scrollTop: 0, scrollLeft: 0 };

  private lastPosition = { scrollTop: 0, scrollLeft: 0 };

  private lastHue = this.hueStart;

  private maxScroll = {
    scrollTop: document.body.scrollHeight - window.innerHeight,
    scrollLeft: document.body.scrollWidth - window.innerWidth,
  };

  /** compute a hue from a number of pixels scrolled */
  private hueFromScrollPosition(scroll = this.scrollPosition): number {
    const position = scroll.scrollTop;
    const boundary = this.maxScroll.scrollTop;
    const scrollFactor = (position / boundary);
    const delta = (this.hueEnd - this.hueStart) * scrollFactor;
    const hue = this.hueStart + delta;

    return hue;
  }

  private hasScrollChanged(): boolean {
    return (
      this.scrollPosition.scrollLeft !== this.lastPosition.scrollLeft ||
      this.scrollPosition.scrollTop !== this.lastPosition.scrollTop
    );
  }

  private onResize(): void {
    const scrollLeft = document.body.scrollWidth - window.innerWidth;
    const scrollTop = document.body.scrollHeight - window.innerHeight;
    Object.assign(this.maxScroll, { scrollLeft, scrollTop });
  }

  private animateHue(): void {
    if (this.hasScrollChanged()) {
      const hue = this.hueFromScrollPosition(this.scrollPosition);
      if (this.lastHue !== hue)
        document.documentElement.style.setProperty('--primary-hue', hue.toString());
      this.lastHue = hue;
    }
    Object.assign(this.lastPosition, this.scrollPosition);
    requestAnimationFrame(this.animateHue.bind(this));
  }

  private onScroll(): void {
    const { scrollLeft, scrollTop } = document.documentElement;
    Object.assign(this.scrollPosition, { scrollLeft, scrollTop });
  }
}
